import { useContext } from 'react';
import { DisplayModeContext } from './DisplayModeContext';

export const useDisplayModeContext = () => useContext(DisplayModeContext);
